import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseurlService} from '../../services/baseurl.service';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScreenshotStreamService {

  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) { }

  getScreenshotSummaries(): Observable<Array<StracliScreenshotSummary>> {
    return this.http.get<Array<StracliScreenshotSummary>>(`${this.baseurlService.getBaseUrl()}/stracliScreenshots/hosts`);
  }

  getScreenshot(host: string): Observable<StracliScreenshot> {
    return this.http.get<StracliScreenshot>(`${this.baseurlService.getBaseUrl()}/stracliScreenshots/hosts/${encodeURIComponent(host)}`);
  }
}

export interface StracliScreenshotSummary {
  host: string;
  captured: string;
  sequence: number;
  screenCount: number;
  imageBytes: number;
}

export interface StracliScreenshot {
  uid: string;
  host: string;
  captured: string;
  sequence: number;
  intervalMillis: number;
  format: string;
  screenCount: number;
  imageBytes: number;
  osName: string | null;
  osVersion: string | null;
  captureMillis: number;
  screens: Array<StracliScreenshotScreen>;
}

export interface StracliScreenshotScreen {
  index: number;
  deviceId: string | null;
  primary: boolean;
  boundsX: number;
  boundsY: number;
  boundsWidth: number;
  boundsHeight: number;
  width: number;
  height: number;
  scaleFactor: number;
  refreshRate: number | null;
  bitDepth: number | null;
  captureMillis: number;
  imageBytes: number;
  imageBase64: string;
}
